jQuery( document ).ready(function($) {
    const masthead_height = $('.masthead_cont').outerHeight(true);
    const masthead_breaks = 3;
    const masthead_height_breaks = masthead_height / masthead_breaks;
    let opacity = 0.8;
    let new_opacity = 0.8;
    header_opactity_adjustment();
  
    $(window).scroll(function() { //when window is scrolled
        header_opactity_adjustment();
    });

    function header_opactity_adjustment() {
        if($(window).scrollTop() > (masthead_height_breaks * (masthead_breaks - 1))) {
            new_opacity = 1;
        }
        else if ($(window).scrollTop() > masthead_height_breaks) {
            new_opacity = 0.9;
        }
        else {
            new_opacity = 0.8;
        }
        if (opacity != new_opacity) {
            opacity = new_opacity;
            $('.main-nav-wrapper').css('background','hsla(0,20%,98%,' + opacity + ')' );
        }
    }
});


